import type { AuditEntriesFetchedAction } from '@Application/AuditTrail/Actions/auditEntriesFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import AuditEntriesListView from '@UI/Store/AuditTrail/Views/AuditEntriesListView';
import AuditEntryView from '@UI/Store/AuditTrail/Views/AuditEntryView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AuditTrailStore = {
	entries: AuditEntriesListView | null;
};

const initialState: AuditTrailStore = {
	entries: null,
};

type Actions = AuditEntriesFetchedAction | UserRevokedAction;

const whenAuditEntriesFetched = (
	store: AuditTrailStore,
	action: AuditEntriesFetchedAction,
): AuditTrailStore => ({
	...store,
	entries: AuditEntriesListView.replaceAll(
		action.payload.results.map((entry) => new AuditEntryView(entry)),
		action.accountId,
		action.payload.totalRecords,
	),
});

// An audit trail is the last data that should be allowed to survive a logout.
const whenUserRevoked = (): AuditTrailStore => initialState;

export default registerStore<'auditTrailStore', Actions>(
	'auditTrailStore',
	createSliceReducer({
		AUDIT_ENTRIES_FETCHED: whenAuditEntriesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
